import React from 'react';
import { BoardingServiceItem, ServicesSectionConfig } from './types';
import { Service } from 'model/Service';
import ServicesTable from './ServicesTable';
import styles from './ServicesSection.module.scss';

interface ServicesSectionProps {
    services: BoardingServiceItem[];
    availableServices: Service[];
    onChange: (services: BoardingServiceItem[]) => void;
    error?: string;
    isLoading?: boolean;
    config: ServicesSectionConfig;
}

export const ServicesSection: React.FC<ServicesSectionProps> = ({
    services,
    availableServices,
    onChange,
    error,
    isLoading,
    config
}) => {
    return (
        <div className={styles.container}>
            <h3 className={styles.title}>
                Select Services <span className={styles.required}>*</span>
            </h3>
            <p className={styles.description}>{config.description}</p>

            {error && <div className={styles.error}>{error}</div>}

            {isLoading ? (
                <div className={styles.skeletonContainer}>
                    <div className={styles.skeletonRow} />
                    <div className={styles.skeletonRow} />
                    <div className={styles.skeletonRow} />
                </div>
            ) : (
                <ServicesTable
                    services={services}
                    availableServices={availableServices}
                    onChange={onChange}
                    config={config}
                />
            )}
        </div>
    );
};
